document.addEventListener('DOMContentLoaded', () => {
    const tickerContainer = document.querySelector('.ticker-container');
    const tickerContent = document.getElementById('ticker');

    // bail if missing container or content wrapper
    if (!tickerContainer || !tickerContent) return;

    // grab the first child to use as a template
    const baseItem = tickerContent.firstElementChild;
    // bail if there is nothing inside #ticker yet
    if (!baseItem) return;

    function fillTicker() {
        const containerWidth = tickerContainer.offsetWidth;
        let contentWidth = tickerContent.offsetWidth;

        while (contentWidth < containerWidth * 2) {
            const newItem = baseItem.cloneNode(true);
            tickerContent.appendChild(newItem);
            contentWidth = tickerContent.offsetWidth;
        }
    }

    fillTicker();
    window.addEventListener('resize', () => {
        tickerContent.innerHTML = '';
        tickerContent.appendChild(baseItem.cloneNode(true));
        fillTicker();
    });
});
